<template>
  <div class="support">
    <h1>Support</h1>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {
      }
    },
    name: 'support',
    components: {
    },
    methods: {
    },
    created: function () {

    },
    computed: {
    }
  }
</script>

<style scoped>
</style>
